import { render, staticRenderFns } from "./CustomerDetailsOverview.vue?vue&type=template&id=0ba66ca6&scoped=true"
import script from "./CustomerDetailsOverview.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailsOverview.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDetailsOverview.vue?vue&type=style&index=0&id=0ba66ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba66ca6",
  null
  
)

export default component.exports